import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';

const Container = styled.section`
  background-color: ${brand.grey['97']};
  padding: 0px 0px 25px 0px;

  .tk-treble-app > :first-child {
    grid-column: 1/-1;
  }

  .mw-header {
    background-color: #db011c;
    padding: 20px;
  }

  .mw-logo {
    height: 40px;
  }

  .tk-display-title.tk-title {
    font-size: 18px;
  }

  .tk-treble-form {
    margin-right: 16px;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 10px 0px 45px 0px;
  }
`;

const Media = styled.div`
  display: none;

  @media ${from(Device.TabletLarge)} {
    display: block;
    grid-column: span 7;

    position: sticky;
    top: 25px;
    height: max-content;
    max-height: 100%;
    z-index: 1;
  }
`;

const Content = styled.div`
  grid-column: span 12;

  @media ${from(Device.TabletLarge)} {
    grid-column: span 5;
  }
`;

const ThreeKit = styled.div`
  grid-column: span 12;
`;

export const ProductToolOverviewStyles = {
  Media,
  Content,
  Container,
  ThreeKit,
};
